import { type MaterialBrightnessFilter } from '$/services/usecases/materials';

export type SpectrumWidgetFilter = {
  collection: string;
  colorGroups: string[];
  brightness: MaterialBrightnessFilter;
  query: string;
};

export type SpectrumWidgetFilterInput = {
  collection?: string;
  colorGroups?: string[];
  brightnessMin?: number;
  brightnessMax?: number;
  query?: string;
};

const toText = (value: unknown) =>
  typeof value === 'string' || typeof value === 'number'
    ? String(value)
    : undefined;

const toPercent = (value: unknown) =>
  typeof value === 'number' && Number.isFinite(value)
    ? Math.min(100, Math.max(0, value))
    : undefined;

export const parseWidgetFilter = (
  input: Record<string, unknown>,
): SpectrumWidgetFilterInput => {
  const colorGroups = [input.colorGroups]
    .flat()
    .filter((value) => typeof value === 'string');

  return {
    collection: toText(input.collection),
    colorGroups: colorGroups.length > 0 ? colorGroups : undefined,
    brightnessMin: toPercent(input.brightnessMin),
    brightnessMax: toPercent(input.brightnessMax),
    query: toText(input.query),
  };
};
